export const SoundMap = {
  bell: '/assets/sound/mixkit-achievement-bell-600.mp3',
  tick: '/assets/sound/mixkit-fast-wall-clock-ticking-1063.mp3',
}

export const BELL_SOUND_ID = 'bell-sound'
export const TICK_SOUND_ID = 'tick-sound'
